module.exports = __webpack_public_path__ + "static/labcoat.543bbff8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/labcoat.png
// module id = ./src/assets/labcoat.png
// module chunks = 33747463168993 268608278405510